import { render, staticRenderFns } from "./SubscriptionPlanDetail.vue?vue&type=template&id=0c4a44c3&"
import script from "./SubscriptionPlanDetail.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports